/**
 * Position des Geräts (Wertobjekt `Geoposition`, LIM-0009): eine Messung auf Anforderung, nie im Hintergrund. Liefert das
 * Gerät keine Position (keine Freigabe, kein Empfang, Zeitüberschreitung), ist das Ergebnis `null` — eine Meldung wird
 * deshalb nie aufgehalten (F-112, F-170: „Ohne Position wird trotzdem gemeldet“).
 */
export interface Messung {
  position: { Breite: number; Länge: number };
  /** Genauigkeit in ganzen Metern */
  genauigkeit: number;
}

const ZEITGRENZE_MS = 10_000;

let letzte: Messung | null = null;

/** Letzte erfolgreiche Messung dieser Sitzung (nur im Speicher), z. B. für den Sonnenstand am Stand (design/darstellung.ts). */
export function letzteMessung(): Messung | null {
  return letzte;
}

export function positionMessen(zeitgrenzeMs = ZEITGRENZE_MS): Promise<Messung | null> {
  return new Promise((fertig) => {
    if (!("geolocation" in navigator)) {
      fertig(null);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (p) => {
        letzte = { position: { Breite: p.coords.latitude, Länge: p.coords.longitude }, genauigkeit: Math.round(p.coords.accuracy) };
        fertig(letzte);
      },
      () => fertig(null),
      { enableHighAccuracy: true, timeout: zeitgrenzeMs, maximumAge: 0 },
    );
  });
}

/** Wartet höchstens `ms` auf eine laufende Messung; danach gilt „keine Position“ (die Meldung geht ohne sie). */
export function hoechstens(messung: Promise<Messung | null>, ms: number): Promise<Messung | null> {
  return Promise.race([messung, new Promise<null>((fertig) => window.setTimeout(() => fertig(null), ms))]);
}

/** Übergabe an die Karten-App des Geräts (oberflaeche.md §6 „Navigation“). */
export function navigieren(p: { Breite: number; Länge: number } | null | undefined): void {
  if (p) window.open(`geo:${p.Breite.toFixed(6)},${p.Länge.toFixed(6)}`, "_blank");
}

/** Übergabe einer Adresse an die Karten-App (Route zum Tierarzt, §5 „Route zu“). */
export function routeZu(adresse: string | null | undefined): void {
  if (adresse) window.open(`geo:0,0?q=${encodeURIComponent(adresse)}`, "_blank");
}

/** Anruf über die Telefon-App des Geräts (Ein-Tipp-Anruf). */
export function anrufen(nummer: string | null | undefined): void {
  if (nummer) window.location.href = `tel:${nummer.replace(/\s+/g, "")}`;
}
